"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Packaging = exports.EPackagingType = void 0;
const Dimension_1 = require("./Dimension");
const Common_1 = require("./Common");
const index_1 = require("../index");
var EPackagingType;
(function (EPackagingType) {
    EPackagingType["PALLET"] = "pallet";
    EPackagingType["BOX"] = "box";
    EPackagingType["OTHER"] = "other";
    EPackagingType["NONE"] = "";
})(EPackagingType || (exports.EPackagingType = EPackagingType = {}));
class Packaging extends index_1.Base {
    name = '';
    type = EPackagingType.NONE;
    dimensions = new Dimension_1.DimensionArray();
    cost = null;
    quantity = null;
    weight = null;
    weight_ounces = null;
    manual = false;
    nmfc_class = '';
    nmfc_number = '';
    ltl = null;
    liftgate = false;
    handlingUnit = ''; // Used for GMTL to override the handling unit from Pallet to Other.
    items = [];
    _m = ['dimensions', 'quantity', 'manual', 'nmfc_class', 'weight', 'ltl', 'items'];
    get pieces() {
        let n = 0;
        this.items.forEach(i => n = n + (i.quantity || 0));
        return n;
    }
    constructor(data, olMap) {
        super('packaging', 12);
        (0, Common_1.setObjectProperties)(this, data, olMap, Packaging);
    }
    setDimensions() {
        if (this.manual)
            return;
        let h = 0;
        let w = 0;
        let l = 0;
        this.weight = 0;
        if (this.items?.length) {
            for (let item of this.items) {
                this.weight += ((item.unit_weight || 0) * (item.quantity || 0));
                w += item.dimensions.get('Width')?.size || 0;
                if ((item.dimensions.get('Height')?.size || 0) > h) {
                    h = item.dimensions.get('Height')?.size || 0;
                }
                if ((item.dimensions.get('Length')?.size || 0) > l) {
                    l = item.dimensions.get('Length')?.size || 0;
                }
            }
        }
        if (this.weight < 1) {
            this.weight = (0, Common_1.round)(this.weight, 2);
        }
        else {
            this.weight = (0, Common_1.round)(this.weight, 0);
        }
        this.weight_ounces = this.weight ? (0, Common_1.round)((this.weight * 16), 0) : 8;
        // Default small packages to 8oz?
        this.dimensions.get('Width')?.setSize(w);
        this.dimensions.get('Height')?.setSize(h);
        this.dimensions.get('Length')?.setSize(l);
    }
    toString() {
        let parts = [];
        if (this.items?.length || this.weight) {
            if (this.weight) {
                parts.push(`${this.weight} lb`);
            }
            for (let p of this.items || []) {
                parts.push(`${p.quantity} ${p.name}`);
            }
        }
        else {
            parts.push('empty');
        }
        if (this.type) {
            return `${this.type.toUpperCase()}: ${parts.join(' ~ ')}`;
        }
        else {
            return `${parts.join('; ')}`;
        }
    }
}
exports.Packaging = Packaging;
index_1.olm.packaging = (ref, map) => {
    return new Packaging(ref, map);
};
